module.exports = __webpack_public_path__ + "media/income.cf17cfb3.mp3";